export default __webpack_public_path__ + "images/238baf0e6ef98d7ce0976e6b7261079d.png";